module.exports = __webpack_public_path__ + "page13One-a0b8b9d00947be915556ab7ce32bc53e.png";